import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Checkbox,
  ListItemText,
  Tabs,
  Tab,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import "../home/home.scss";
import Swal from "sweetalert2";
// import * as XLSX from "xlsx";
import {
  MdDelete,
  MdClose,
  MdVisibility,
  MdKeyboardArrowUp,
  MdSearch,
} from "react-icons/md";

const tabsData = [
  "OFAC",
  "UK sanctions",
  "NON SDN",
  "Others",
];

function ImportData() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState([]);
  const [modalName, setModalName] = useState("");
  const [fileTypeOptions] = useState([
    "PEP",
    "Grey List",
    "White List",
  ]);
  const handleCloseModal = () => {
    setModalOpen(false);
    setModalType([]);
    setModalName("");
  };
  const [selectedTab, setSelectedTab] = useState(0);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileInputs, setFileInputs] = useState([
    { id: Date.now(), files: [] },
  ]);
  // Change submittedData to store files per tab
  const [submittedData, setSubmittedData] = useState(
    tabsData.reduce((acc, tab) => {
      acc[tab] = [];
      return acc;
    }, {})
  );

  const [showHistory, setShowHistory] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewFilesModal, setViewFilesModal] = useState(false);

  // Add separate states for modal view
  const [modalSelectedFile, setModalSelectedFile] = useState(null);
  const [modalSearchTerm, setModalSearchTerm] = useState("");
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const modalItemsPerPage = 5;

  // Add this after the existing state declarations
  const [currentPage, setCurrentPage] = useState(1);
  const [previewCurrentPage, setPreviewCurrentPage] = useState(1);
  const [modalPreviewCurrentPage, setModalPreviewCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setSelectedFile(null); // Clear selected file when switching tabs
  };

  const handleFileChange = (id, event) => {
  const selectedFile = event.target.files[0]; // only one file
  const updatedInputs = fileInputs.map((input) =>
    input.id === id ? { ...input, files: selectedFile } : input
  );
  setFileInputs(updatedInputs);
};

  const handleNextClick = () => {
  const validInputs = fileInputs.filter((input) => input.files);

  if (validInputs.length === 0) {
    Swal.fire({
      title: "Missing Files",
      text: "Please select at least one file.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  const currentTab = tabsData[selectedTab];
  setSubmittedData((prevData) => {
    const newData = { ...prevData };

    validInputs.forEach((input) => {
      const file = input.files; // since it's just one file now
      newData[currentTab] = [
        ...(newData[currentTab] || []), // in case it's undefined
        {
          id: Date.now() + Math.random(), // unique ID
          file: file,
          fileType: currentTab,
        },
      ];
    });

    return newData;
  });

  // Reset inputs
  setFileInputs([{ id: Date.now(), files: null }]);
  setRawDataImportModal(false);
};


  const [rawDataImportModal, setRawDataImportModal] = useState(false);
  const handleRawDataImportModal = () => {
    setRawDataImportModal(!rawDataImportModal);
    if (!rawDataImportModal) {
      setFileInputs([{ id: Date.now(), files: [] }]);
    }
  };

 const handleDeleteFile = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      const currentTab = tabsData[selectedTab];

      setSubmittedData((prevData) => {
        const updatedFiles = prevData[currentTab].filter((item) => item.id !== id);

        return {
          ...prevData,
          [currentTab]: updatedFiles,
        };
      });

      Swal.fire("Deleted!", "Your file has been deleted.", "success");
    }
  });
};



  const handleViewFile = (file) => {
    setSelectedFile(file);
    // Scroll to preview section
    const previewSection = document.getElementById("previewSection");
    if (previewSection) {
      previewSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Show/hide scroll button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Export the table data
  // const handleExportXLSX = () => {
  //   const table = document.getElementById("fileTable");
  //   if (!table) {
  //     console.warn("Table not found");
  //     return;
  //   }

  //   // Extract headers
  //   const headers = [];
  //   const headerRow = table.querySelector("thead tr");
  //   if (headerRow) {
  //     headerRow.querySelectorAll("th").forEach((th) => {
  //       headers.push(th.textContent);
  //     });
  //   }

  //   // Extract data rows
  //   const rows = [];
  //   table.querySelectorAll("tbody tr").forEach((tr) => {
  //     const rowData = [];
  //     tr.querySelectorAll("td").forEach((td) => {
  //       rowData.push(td.textContent);
  //     });
  //     rows.push(rowData);
  //   });

  //   // Create the sheet data with headers followed by rows
  //   const sheetData = [headers, ...rows];

  //   // Create worksheet and workbook
  //   const ws = XLSX.utils.aoa_to_sheet(sheetData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Table Data");

  //   const fileName = `reference_data_export.xlsx`;
  //   XLSX.writeFile(wb, fileName);
  // };

  // Add this function to handle search
  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  // Add this function to filter table data
  const getFilteredTableData = () => {
    const allData = previewTableData;
    if (!searchTerm) return allData;

    return allData.filter((row) =>
      Object.values(row).some(
        (value) => value && value.toString().toLowerCase().includes(searchTerm)
      )
    );
  };


  const getFilteredModalPreviewData = () => {
    const allData = modalPreviewTableData;
    const searchTerm = modalSearchTerm?.toLowerCase().trim();
  
    if (!searchTerm) return allData;
  
    return allData.filter((row) =>
      Object.values(row).some(
        (value) =>
          value?.toString().toLowerCase().includes(searchTerm)
      )
    );
  };
  

  // Add pagination functions for main table
  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(
      Math.ceil(submittedData[tabsData[selectedTab]].length / itemsPerPage)
    );
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) =>
      Math.min(
        prev + 1,
        Math.ceil(submittedData[tabsData[selectedTab]].length / itemsPerPage)
      )
    );
  };

  // Add pagination functions for preview tables
  const handlePreviewFirstPage = () => {
    setPreviewCurrentPage(1);
  };

  const handlePreviewLastPage = () => {
    setPreviewCurrentPage(
      Math.ceil(getFilteredTableData().length / itemsPerPage)
    );
  };

  const handlePreviewPrevPage = () => {
    setPreviewCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handlePreviewNextPage = () => {
    setPreviewCurrentPage((prev) =>
      Math.min(
        prev + 1,
        Math.ceil(getFilteredTableData().length / itemsPerPage)
      )
    );
  };

  // Add pagination functions for modal table
  const handleModalFirstPage = () => {
    setModalCurrentPage(1);
  };

  const handleModalLastPage = () => {
    setModalCurrentPage(
      Math.ceil(tableData[tabsData[selectedTab]].length / modalItemsPerPage)
    );
  };

  const handleModalPrevPage = () => {
    setModalCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleModalNextPage = () => {
    setModalCurrentPage((prev) =>
      Math.min(
        prev + 1,
        Math.ceil(tableData[tabsData[selectedTab]].length / modalItemsPerPage)
      )
    );
  };

  // Add pagination functions for modal preview table
  const handleModalPreviewFirstPage = () => {
    setModalPreviewCurrentPage(1);
  };

  const handleModalPreviewLastPage = () => {
    setModalPreviewCurrentPage(
      Math.ceil(getFilteredTableData().length / itemsPerPage)
    );
  };

  const handleModalPreviewPrevPage = () => {
    setModalPreviewCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleModalPreviewNextPage = () => {
    setModalPreviewCurrentPage((prev) =>
      Math.min(
        prev + 1,
        Math.ceil(getFilteredTableData().length / itemsPerPage)
      )
    );
  };

  // Add modal search handler
  const handleModalSearch = (event) => {
    setModalSearchTerm(event.target.value.toLowerCase());
  };

  // Add modal view file handler
  const handleModalViewFile = (file) => {
    setModalSelectedFile(file);
  };

  const previewTableData = [
    {
      id: 0,
      ENT_NUM: 36,
      SDN_NAME: "AEROCARIBBEAN AIRLINES",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 1,
      ENT_NUM: 173,
      SDN_NAME: "ANGLO-CARIBBEAN CO., LTD.",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 2,
      ENT_NUM: 306,
      SDN_NAME: "BANCO NACIONAL DE CUBA",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "a.k.a. 'BNC'."
    },
    {
      id: 3,
      ENT_NUM: 424,
      SDN_NAME: "BOUTIQUE LA MAISON",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 4,
      ENT_NUM: 475,
      SDN_NAME: "CASA DE CUBA",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 5,
      ENT_NUM: 480,
      SDN_NAME: "CECOEX, S.A.",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 6,
      ENT_NUM: 535,
      SDN_NAME: "CIMEX",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 7,
      ENT_NUM: 536,
      SDN_NAME: "CIMEX IBERICA",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 8,
      ENT_NUM: 537,
      SDN_NAME: "CIMEX, S.A.",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
    },
    {
      id: 9,
      ENT_NUM: 540,
      SDN_NAME: "COMERCIAL IBEROAMERICANA, S.A.",
      SDN_TYPE: "-0-",
      Program: "CUBA",
      Title: "-0-",
      Call_Sign: "-0-",
      Vessel_Type: "-0-",
      Tonnage: "-0-",
      GRT: "-0-",
      Vessel_Flag: "-0-",
      Vessel_Owner: "-0-",
      Remarks: "-0-"
      //  Remarks: "-0--"
    }
  ];
  

  const modalPreviewTableData = [
    {
      id: 0,
      col1: "BANKSESSXXXX",
      col2: "I103BANKNO2XXXXN",
      col3: "SEPA, MNO987123654",
      col4: "",
      col20: "REF987123654",
      col23B: "CRED",
      col32A: "240303SEK3000",
      col50A: "/9871236540 OLIVER ERICSON",
      col57A: "BANKNO2X",
      col59: "/5566778899 HENRY JOHNSTON",
      col70: "HOUSE RENT",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 1,
      col1: "BANKFIHHXXXX",
      col2: "I103BANKDKKKXXXXN",
      col3: "SEPA, PQR456789123",
      col4: "",
      col20: "REF456789123",
      col23B: "CRED",
      col32A: "240303SEK5000",
      col50A: "/4567891230 EMMA WILSON",
      col57A: "BANKDKKKX",
      col59: "/1122334455 JAMES BROWN",
      col70: "CAR LOAN",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 2,
      col1: "BANKPTPLXXXX",
      col2: "I103BANKGRXXXXXXN",
      col3: "SEPA, STU654321987",
      col4: "",
      col20: "REF654321987",
      col23B: "CRED",
      col32A: "240303SEK7000",
      col50A: "/6543219870 LUCAS MARTIN",
      col57A: "BANKGRXXX",
      col59: "/9988776655 SARAH DAVIS",
      col70: "HOME RENOVATION",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 3,
      col1: "BANKESPBXXXX",
      col2: "I103BANKITRRXXXXN",
      col3: "SEPA, VWX321654987",
      col4: "",
      col20: "REF321654987",
      col23B: "CRED",
      col32A: "240303SEK4000",
      col50A: "/3216549870 SOPHIA LEE",
      col57A: "BANKITRRX",
      col59: "/4455667788 MICHAEL WHITE",
      col70: "EDUCATION",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 4,
      col1: "BANKDEFFXXXX",
      col2: "I103BANKFRXXXXXXN",
      col3: "SEPA, YZA987654321",
      col4: "",
      col20: "REF987654321",
      col23B: "CRED",
      col32A: "240303SEK6000",
      col50A: "/9876543210 THOMAS CLARK",
      col57A: "BANKFRXXX",
      col59: "/6677889900 LUCY ADAMS",
      col70: "BUSINESS EXPENSE",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
  ];

  // Add this table data
  const tableData = {
    "OFAC": [
      {
        id: 1,
        fileName: "ofac-2024-03-15-120000",
        loadDate: "15-03-2024",
        loadTime: "12:00:00",
      },
      {
        id: 2,
        fileName: "ofac-2024-03-14-150000",
        loadDate: "14-03-2024",
        loadTime: "15:00:00",
      },
      {
        id: 3,
        fileName: "ofac-2024-03-13-180000",
        loadDate: "13-03-2024",
        loadTime: "18:00:00",
      },
    ],
    "PEP": [
      {
        id: 1,
        fileName: "pep-2024-03-15-130000",
        loadDate: "15-03-2024",
        loadTime: "13:00:00",
      },
      {
        id: 2,
        fileName: "pep-2024-03-14-160000",
        loadDate: "14-03-2024",
        loadTime: "16:00:00",
      },
      {
        id: 3,
        fileName: "pep-2024-03-13-190000",
        loadDate: "13-03-2024",
        loadTime: "19:00:00",
      },
    ],
    "UK sanctions": [
      {
        id: 1,
        fileName: "uk-sanctions-2024-03-15-140000",
        loadDate: "15-03-2024",
        loadTime: "14:00:00",
      },
      {
        id: 2,
        fileName: "uk-sanctions-2024-03-14-170000",
        loadDate: "14-03-2024",
        loadTime: "17:00:00",
      },
      {
        id: 3,
        fileName: "uk-sanctions-2024-03-13-200000",
        loadDate: "13-03-2024",
        loadTime: "20:00:00",
      },
    ],
    "NON SDN": [
      {
        id: 1,
        fileName: "non-sdn-2024-03-15-150000",
        loadDate: "15-03-2024",
        loadTime: "15:00:00",
      },
      {
        id: 2,
        fileName: "non-sdn-2024-03-14-180000",
        loadDate: "14-03-2024",
        loadTime: "18:00:00",
      },
      {
        id: 3,
        fileName: "non-sdn-2024-03-13-210000",
        loadDate: "13-03-2024",
        loadTime: "21:00:00",
      },
    ],
    "Grey List": [
      {
        id: 1,
        fileName: "grey-list-2024-03-15-160000",
        loadDate: "15-03-2024",
        loadTime: "16:00:00",
      },
      {
        id: 2,
        fileName: "grey-list-2024-03-14-190000",
        loadDate: "14-03-2024",
        loadTime: "19:00:00",
      },
      {
        id: 3,
        fileName: "grey-list-2024-03-13-220000",
        loadDate: "13-03-2024",
        loadTime: "22:00:00",
      },
    ],
    "White List": [
      {
        id: 1,
        fileName: "white-list-2024-03-15-170000",
        loadDate: "15-03-2024",
        loadTime: "17:00:00",
      },
      {
        id: 2,
        fileName: "white-list-2024-03-14-200000",
        loadDate: "14-03-2024",
        loadTime: "20:00:00",
      },
      {
        id: 3,
        fileName: "white-list-2024-03-13-230000",
        loadDate: "13-03-2024",
        loadTime: "23:00:00",
      },
    ],
    "Others": [
      {
        id: 1,
        fileName: "others-2024-03-15-180000",
        loadDate: "15-03-2024",
        loadTime: "18:00:00",
      },
      {
        id: 2,
        fileName: "others-2024-03-14-210000",
        loadDate: "14-03-2024",
        loadTime: "21:00:00",
      },
      {
        id: 3,
        fileName: "others-2024-03-13-240000",
        loadDate: "13-03-2024",
        loadTime: "24:00:00",
      },
    ],
  };
  const handleOpenModal = () => {
    // setModalType("Current");
    // setModalFile([]);
    // setModalScenario([]);
    setModalOpen(true);
  };

  return (
    <div className="home-page">
      <div className="page-container">
        {/* Horizontal Scrolling Tabs - replaced Box with Bootstrap row */}
        <div className="row border-bottom mb-3" style={{ borderColor: '#dee2e6' }}>
          <div className="col-12">
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="reference data tabs"
              sx={{
                '& .MuiTabs-indicator': { display: 'none' },
                '& .MuiTab-root': {
                  color: 'rgba(0, 0, 0, 0.6)',
                  backgroundColor: '#ccc',
                  padding: '15px',
                  borderRadius: '4px 4px 0 0',
                  marginRight: '5px',
                  '&.Mui-selected': {
                    backgroundColor: 'var(--theme-color)',
                    color: 'white',
                    borderRadius: '4px 4px 0 0',
                  }
                }
              }}
            >
              {tabsData.map((tab, index) => (
                <Tab key={index} label={tab} />
              ))}
            </Tabs>
          </div>
        </div>

        <div className="row justify-content-between align-items-end mb-4">
          <div className="col-12 col-md-3 ">
            <button
              className="anchor-button"
              onClick={() => setViewFilesModal(true)}
            >
              View Files
            </button>
          </div>
          <div className="col-12 col-md-3 text-end">
            {tabsData[selectedTab] === "Others" && (
              <button className="btn cancelButton" onClick={handleOpenModal}>
                + Create{" "}
              </button>
            )}
            <button
              className="btn createButton mx-2"
              onClick={handleRawDataImportModal}
            >
              Import
            </button>
          </div>
        </div>

        {/* Upload Modal */}
        {rawDataImportModal && (
          <div className="modal-overlay">
            <div className="modal-container">
              <div className="row justify-content-center align-items-center">
                <div className="col-12 d-flex justify-content-between align-items-center">
                  <h5 className="mt-4">Upload {tabsData[selectedTab]} File</h5>
                  <button
                    className="border-0 bg-transparent"
                    onClick={handleRawDataImportModal}
                  >
                    <MdClose color="black" fontSize={20} />
                  </button>
                </div>
              </div>
              {fileInputs.map(({ id, files }, index) => (
                <React.Fragment key={id}>
                    {(tabsData[selectedTab] === "OFAC" || tabsData[selectedTab] === "NON SDN") && (
                        <div className="col-6 mt-3">
                            <FormControl size="small">
                            <InputLabel>File Name</InputLabel>
                            <Select label="File Name" disableUnderline sx={{ minWidth: 400 }}>
                                <MenuItem value="Address">
                                <ListItemText primary="Address" />
                                </MenuItem>

                                {tabsData[selectedTab] === "OFAC" && (
                                <MenuItem value="SDN">
                                    <ListItemText primary="SDN" />
                                </MenuItem>
                                )}

                                {tabsData[selectedTab] === "NON SDN" && (
                                <MenuItem value="NON SDN">
                                    <ListItemText primary="NON SDN" />
                                </MenuItem>
                                )}
                            </Select>
                            </FormControl>
                        </div>
                    )}
                  <div className="row justify-content-between align-items-center mb-3">
                    <div className="col-12">
                      <div className="choose-file-input d-flex align-items-center">
                        <label
                          className="btn choose-file-btn me-2"
                          htmlFor={`fileInput-${id}`}
                        >
                          Choose Files
                        </label>
                        <input
                          id={`fileInput-${id}`}
                          type="file"
                          style={{ display: "none" }}
                          onChange={(e) => handleFileChange(id, e)}
                        />
                        <p
                          className="mb-0 choose-file-name flex-grow-1"
                          onClick={() =>
                            document.getElementById(`fileInput-${id}`).click()
                          }
                        >
                          {files ? files.name : "No file chosen"}
                        </p>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
              <div className="d-flex justify-content-end mt-3 gap-3">
                <button
                  className="btn createButton"
                  onClick={handleNextClick}
                >
                  Upload
                </button>
                <button
                  className="btn cancelButton"
                  onClick={handleRawDataImportModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Files Table */}
        <div className="table-responsive">
          <table
            className="table table-bordered table-striped mt-2"
            id="abbreviationsTable"
          >
            <thead className="table-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">File Type</th>
                <th scope="col">File Name</th>
                <th scope="col" className="text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {submittedData[tabsData[selectedTab]]
                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                .map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{tabsData[selectedTab]}</td>
                    <td>{item.file ? item.file.name : ""}</td>
                    <td className="d-flex justify-content-center align-items-center gap-2">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleViewFile(item)}
                      >
                        <MdVisibility /> View
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDeleteFile(item.id)}
                      >
                        <MdDelete /> Delete
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Add pagination for main table */}
        <div className="d-none justify-content-end mt-3 ">
          <div className="pagination">
            <Button
              variant="outlined"
              size="small"
              onClick={handleFirstPage}
              disabled={currentPage === 1}
              className="me-2"
            >
              First
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="me-2"
            >
              Prev
            </Button>
            <span className="mx-2 align-self-center">
              Page {currentPage} of{" "}
              {Math.ceil(
                submittedData[tabsData[selectedTab]].length / itemsPerPage
              )}
            </span>
            <Button
              variant="outlined"
              size="small"
              onClick={handleNextPage}
              disabled={
                currentPage ===
                Math.ceil(
                  submittedData[tabsData[selectedTab]].length / itemsPerPage
                )
              }
              className="me-2"
            >
              Next
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleLastPage}
              disabled={
                currentPage ===
                Math.ceil(
                  submittedData[tabsData[selectedTab]].length / itemsPerPage
                )
              }
            >
              Last
            </Button>
          </div>
        </div>

        {/* Preview Section */}
        {selectedFile && (
          <div id="previewSection" className="mt-4">
            <h3>Preview</h3>
            <div className="row mb-3 justify-content-between">
              <div className="col-md-4">
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-md-3 d-none">
                {/* DatePicker hidden, keep for future if needed */}
              </div>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped mt-2"
                id="fileTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">ENT_NUM</th>
                    <th scope="col">SDN_NAME</th>
                    <th scope="col">SDN_TYPE</th>
                    <th scope="col">Program</th>
                    <th scope="col">Title</th>
                    <th scope="col">Call_Sign</th>
                    <th scope="col">Vessel_Type</th>
                    <th scope="col">Tonnage</th>
                    <th scope="col">GRT</th>
                    <th scope="col">Vessel_Flag</th>
                    <th scope="col">Vessel_Owner</th>
                    <th scope="col">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {getFilteredTableData()
                    .slice((previewCurrentPage - 1) * itemsPerPage, previewCurrentPage * itemsPerPage)
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(previewCurrentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.ENT_NUM}</td>
                        <td>{row.SDN_NAME}</td>
                        <td>{row.SDN_TYPE}</td>
                        <td>{row.Program}</td>
                        <td>{row.Title}</td>
                        <td>{row.Call_Sign}</td>
                        <td>{row.Vessel_Type}</td>
                        <td>{row.Tonnage}</td>
                        <td>{row.GRT}</td>
                        <td>{row.Vessel_Flag}</td>
                        <td>{row.Vessel_Owner}</td>
                        <td>{row.Remarks}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <div className="text-center d-none">
                <button
                  className="btn createButton"
                  onClick={() => setShowHistory(!showHistory)}
                >
                  {showHistory ? "View Current" : "View History"}
                </button>
              </div>
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePreviewFirstPage}
                  disabled={previewCurrentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePreviewPrevPage}
                  disabled={previewCurrentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {previewCurrentPage} of{" "}
                  {Math.ceil(getFilteredTableData().length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePreviewNextPage}
                  disabled={
                    previewCurrentPage ===
                    Math.ceil(getFilteredTableData().length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePreviewLastPage}
                  disabled={
                    previewCurrentPage ===
                    Math.ceil(getFilteredTableData().length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Scroll to Top Button */}
        {showScrollButton && (
          <button className="scroll-to-top-btn" onClick={scrollToTop}>
            <MdKeyboardArrowUp />
          </button>
        )}

        {/* Add the View Files Modal */}
         {viewFilesModal && (
          <div className="modal-overlay">
            <div
              className="modal-container bg-white"
              style={{
                maxWidth: "90%",
                width: "90%",
                maxHeight: "90vh", // Set maximum height to 90% of viewport height
                height: "auto",
                overflowY: "auto", // Enable vertical scrolling for the entire modal
                display: "flex",
                flexDirection: "column"
              }}
            >
              {/* Header Section */}
              <div className="row justify-content-center align-items-center bg-white z-index-1">
                <div className="col-12 d-flex justify-content-between align-items-center py-3 border-bottom">
                  <h5 className="m-0 px-2">View Files</h5>
                  <button
                    className="border-0 bg-transparent"
                    onClick={() => {
                      setViewFilesModal(false);
                      setModalSelectedFile(null);
                      setModalSearchTerm("");
                      setModalCurrentPage(1);
                    }}
                  >
                    <MdClose color="black" fontSize={20} />
                  </button>
                </div>
              </div>
        
              {/* Main Content with Single Scroll */}
              <div className="modal-body p-3">
                {/* Table Section (File List) - Always visible */}
                <div className="mb-4">
                  <h6 className="mb-3">File List</h6>
                  <div className="table-responsive border rounded bg-white shadow-sm">
                    <table className="table table-bordered table-striped mb-0">
                      <thead className="table-dark">
                        <tr>
                          <th>#</th>
                          <th>File Name</th>
                          <th>Load Date</th>
                          <th>Load Time</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData[tabsData[selectedTab]]
                          .slice(
                            (modalCurrentPage - 1) * modalItemsPerPage,
                            modalCurrentPage * modalItemsPerPage
                          )
                          .map((row, index) => (
                            <tr key={row.id}>
                              <td>
                                {(modalCurrentPage - 1) * modalItemsPerPage +
                                  index +
                                  1}
                              </td>
                              <td>{row.fileName}</td>
                              <td>{row.loadDate}</td>
                              <td>{row.loadTime}</td>
                              <td className="text-center">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  startIcon={<MdVisibility />}
                                  onClick={() => handleModalViewFile(row)}
                                >
                                  View
                                </Button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
        
                  {/* Pagination Controls for File Table */}
                  <div className="d-flex justify-content-end mt-3">
                    <div className="pagination">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleModalFirstPage}
                        disabled={modalCurrentPage === 1}
                        className="me-2"
                      >
                        First
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleModalPrevPage}
                        disabled={modalCurrentPage === 1}
                        className="me-2"
                      >
                        Prev
                      </Button>
                      <span className="mx-2 align-self-center">
                        Page {modalCurrentPage} of{" "}
                        {Math.ceil(
                          tableData[tabsData[selectedTab]].length /
                            modalItemsPerPage
                        )}
                      </span>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleModalNextPage}
                        disabled={
                          modalCurrentPage ===
                          Math.ceil(
                            tableData[tabsData[selectedTab]].length /
                              modalItemsPerPage
                          )
                        }
                        className="me-2"
                      >
                        Next
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleModalLastPage}
                        disabled={
                          modalCurrentPage ===
                          Math.ceil(
                            tableData[tabsData[selectedTab]].length /
                              modalItemsPerPage
                          )
                        }
                      >
                        Last
                      </Button>
                    </div>
                  </div>
                </div>
        
                {/* Preview Section - Appears when a file is selected, but doesn't collapse the first table */}
                {modalSelectedFile && (
                  <div className="mt-4 pt-2 border-top">
                    <h6 className="mb-3">File Preview: {modalSelectedFile.fileName}</h6>
                    <div className="row mb-3 justify-content-between">
                      <div className="col-md-4">
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          placeholder="Search"
                          value={modalSearchTerm}
                          onChange={handleModalSearch}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <MdSearch />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className="table-responsive border rounded">
                      <table
                        className="table table-bordered table-striped mb-0"
                        id="filePreviewTable"
                      >
                        <thead className="table-dark">
                          <tr>
                            <th>#</th>
                            <th>ENT_NUM</th>
                            <th>SDN_NAME</th>
                            <th>SDN_TYPE</th>
                            <th>Program</th>
                            <th>Title</th>
                            <th>Call_Sign</th>
                            <th>Vessel_Type</th>
                            <th>Tonnage</th>
                            <th>GRT</th>
                            <th>Vessel_Flag</th>
                            <th>Vessel_Owner</th>
                            <th>Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getFilteredModalPreviewData().map((row, index) => (
                            <tr key={row.ENT_NUM || index}>
                              <td>{index + 1}</td>
                              <td>{row.ENT_NUM}</td>
                              <td>{row.SDN_NAME}</td>
                              <td>{row.SDN_TYPE}</td>
                              <td>{row.Program}</td>
                              <td>{row.Title}</td>
                              <td>{row.Call_Sign}</td>
                              <td>{row.Vessel_Type}</td>
                              <td>{row.Tonnage}</td>
                              <td>{row.GRT}</td>
                              <td>{row.Vessel_Flag}</td>
                              <td>{row.Vessel_Owner}</td>
                              <td>{row.Remarks}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination Controls for Preview Table */}
                    <div className="d-flex justify-content-end mt-3">
                      <div className="pagination">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleModalPreviewFirstPage}
                          disabled={modalPreviewCurrentPage === 1}
                          className="me-2"
                        >
                          First
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleModalPreviewPrevPage}
                          disabled={modalPreviewCurrentPage === 1}
                          className="me-2"
                        >
                          Prev
                        </Button>
                        <span className="mx-2 align-self-center">
                          Page {modalPreviewCurrentPage} of{" "}
                          {Math.ceil(
                            getFilteredModalPreviewData().length / itemsPerPage
                          )}
                        </span>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleModalPreviewNextPage}
                          disabled={
                            modalPreviewCurrentPage ===
                            Math.ceil(
                              getFilteredModalPreviewData().length / itemsPerPage
                            )
                          }
                          className="me-2"
                        >
                          Next
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleModalPreviewLastPage}
                          disabled={
                            modalPreviewCurrentPage ===
                            Math.ceil(
                              getFilteredModalPreviewData().length / itemsPerPage
                            )
                          }
                        >
                          Last
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Add New</DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>
              File Type
            </div>
            <FormControl fullWidth size="small">
              <Select
                multiple
                value={modalType}
                onChange={(e) => setModalType(e.target.value)}
                renderValue={(selected) => selected.join(", ")}
              >
                {fileTypeOptions.map((type) => (
                  <MenuItem key={type} value={type}>
                    <Checkbox checked={modalType.indexOf(type) > -1} />
                    <ListItemText primary={type} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Name</div>
            <TextField
              fullWidth
              size="small"
              value={modalName}
              onChange={(e) => setModalName(e.target.value)}
              placeholder="Enter name"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="outlined">
            Cancel
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            disabled={modalType.length === 0 || !modalName.trim()}
            onClick={handleCloseModal}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ImportData;
